<template>
  <div class="payment1">
    <c-inputLine
      name="userName"
      maxLength="50"
      :promptText="promptText1"
      :errorHave="true"
      :errorText="errorText1"
      :errorFlag="checkErrorFlag1"
      marginTop="0px"
      :disabled="excheifFlag ? false : isCanModifyName"
      :value="checkValue1"
      @onchanges="inputChanges"
      newStyleFormat
    >
    </c-inputLine>
    <c-select
      :value="mobile"
      :promptText="$t('personal.setUp.paymentMethods.paymentsWA.type')"
      @onChanges="typeChanges"
      :errorHave="true"
      name="mobile"
      :options="mobileList"
      newStyleFormat
    />
    <c-inputLine
      name="account"
      maxLength="50"
      :promptText="promptText2"
      :errorHave="true"
      :errorText="errorText2"
      :errorFlag="checkErrorFlag2"
      marginTop="0px"
      :value="checkValue2"
      @onchanges="inputChanges"
      newStyleFormat
    >
    </c-inputLine>
  </div>
</template>

<script>
export default {
  name: 'paypal',
  props: {
    payments: {
      default: () => {},
      type: Object,
    },
  },
  data() {
    return {
      promptText1: '',
      errorText1: '',
      checkErrorFlag1: false,
      checkValue1: '',
      promptText2: '',
      errorText2: '',
      checkErrorFlag2: false,
      checkValue2: '',
      mobile: '',
    };
  },
  computed: {
    mobileList() {
      return [
        { value: this.$t('otcDetailOrder.phone'), code: '1' },
        { value: this.$t('personal.label.email'), code: '0' },
      ];
    },
    userInfo() {
      return this.$store.state.baseData.userInfo;
    },
    isCanModifyName() {
      return this.userInfo && Number(this.userInfo.userCompanyInfo.status) === 0;
    },
    excheifFlag() {
      return this.$store.state.baseData.exchief_project_switch;
    },
  },
  watch: {
    userInfo(v) {
      if (this.isCanModifyName) {
        if (v) {
          this.checkValue1 = v.realName;
          const obj = {};
          obj.userName = v.realName;
          this.$emit('callBack', 'payment4', 'userName', obj);
        }
      }
    },
    payments(payments) {
      if (payments !== null) {
        this.promptText1 = payments.name;
        this.promptText2 = payments.title;
        if (payments.obj) {
          this.checkValue2 = payments.obj.account;
          this.mobile = String(payments.obj.accountType);
        }
      }
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      if (this.payments !== null) {
        this.promptText1 = this.payments.name;
        this.promptText2 = this.payments.title;
        if (this.payments.obj) {
          this.checkValue1 = this.payments.obj.userName;
          this.checkValue2 = this.payments.obj.account;
        }
      }
      if (this.isCanModifyName) {
        if (this.userInfo) {
          this.checkValue1 = this.userInfo.realName;
          const obj = {};
          obj.userName = this.userInfo.realName;
          this.$emit('callBack', 'payment4', 'userName', obj);
        }
      }
      this.mobile = this.mobileList[0].code;
    },
    inputChanges(value, name) {
      if (name === 'userName') {
        this.checkValue1 = value;
      } else {
        this.checkValue2 = value;
      }
      const obj = {};
      obj[name] = value;
      obj.accountType = this.mobile;
      this.$emit('callBack', 'payment4', name, obj);
    },
    typeChanges(item) {
      this.mobile = item.code;
    },
  },
};
</script>

<style lang="scss" scoped>
.payment1{
  width:100%;
  .upload_div{
    width:120px;
    height:120px;
    border-style: dashed;
    border-width: 1px;
    box-sizing: border-box;
    position: relative;
    overflow: hidden;
    svg {
      margin:36px 47px 12px 47px;
    }
    p{
      font-size: 12px;
      text-align: center;
    }
    .upload_file{
      width: 120px;
      height: 120px;
      position: absolute;
      cursor: pointer;
      top:0;
      left: 0;
      z-index:2;
    }
    .common-button-loading {
      position: absolute;
      vertical-align: middle;
      left: 50%;
      margin-left:-17px;
      top: 45px;
      transform: translateY(-50%)
    }
    .loading-mc{
      position: absolute;
      top:0;
      left:0;
      z-index: 1;
      div{
        width: 100%;
        height: 100%;
        position: absolute;
        top:0;
        left:0;
        opacity:0.7;
      }
      .loading-img{
        width:100%;
        height:100%;
        margin: 0;
      }
    }
    .loading-text2{
      z-index: 3;
      position: relative;
    }
    .loading-text{
      margin-top:70px;
    }
  }
  .upload_p{
    font-size:12px;
    margin: 12px 0 24px 0;
  }
}
</style>
